<app-bucket-list *ngIf="availableBuckets?.length" [buckets]="availableBuckets" title="LABEL_CREDIT_BUCKETS_AVAILABLE"></app-bucket-list>
<app-bucket-list *ngIf="expiredBuckets?.length" [buckets]="expiredBuckets" title="LABEL_CREDIT_BUCKETS_EXPIRED"></app-bucket-list>
<app-bucket-list *ngIf="futureBuckets?.length" [buckets]="futureBuckets" title="LABEL_CREDIT_BUCKETS_FUTURE"></app-bucket-list>

